/**************
 General
 ***************/

// get the header for reference
const header = document.querySelector('#header');
const slider = document.querySelector('#slider');

// specific pages alter the header behavior
if (header.classList.contains('float')) {
// listen for when header hits screen top, apply sticky class
    window.addEventListener('scroll', headerHandle);

    function headerHandle() {
        const headerTop = header.parentElement.getBoundingClientRect().top;
        if (headerTop <= 0) {
            header.classList.add('top');
        } else {
            header.classList.remove('top');
        }
    }

// initial height set
    headerHandle();
}

/**************
 Mobile Nav
 ***************/

// open nav event listener
header.querySelector('#headerMenu').addEventListener("click", () => {
    // find the top of the header and apply to slider top
    slider.style.top = `${header.getBoundingClientRect().top}px`;
    slider.classList.add('active');
    document.querySelector('body').classList.add('noScroll');
    // add listener to escape key to close menu
    document.querySelector('body').addEventListener('keydown', escapeKey);
});

// close nav event listener
slider.querySelector("#sliderExit").addEventListener("click", closeNav);

// close on clicking outside of menu
slider.addEventListener('click', function (e) {
    if (e.target === this) {
        closeNav();
    }
})

// removes no scroll ,listener, and closes menu
function escapeKey(e) {
    if (e.key === "Escape") {
        closeNav();
    }
}

// closes the menu
function closeNav() {
    slider.classList.remove('active');
    document.querySelector('body').classList.remove('noScroll');
    slider.querySelectorAll('.sliderNavButton')?.forEach(el => el.classList.remove('active'));
    // remove listener
    document.querySelector('body').removeEventListener('keydown', escapeKey);
}

// sub menu links
slider.querySelector('.sliderNavButton').addEventListener('click', function () {
    this.classList.toggle('active');
})
